import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OrganizationApi } from 'api';

function useGetAll(enabled = true) {
  return useAuthQuery(
    getQueryKeys([KEY]).lists(),
    () => OrganizationApi.getAll(),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetAll;
